/**
 * Full-page translation for every language we offer. Our own wording (menus, buttons) is translated by hand;
 * everything else on the page is translated by Google's website translator. Elements with class "notranslate"
 * or translate="no" (amounts, codes, names, emails) are left as they are.
 */
const GT: Record<string, string> = { sw: 'sw', es: 'es', pt: 'pt', zh: 'zh-CN', ko: 'ko', fr: 'fr' };
let loaded = false;

function setCookie(v: string | null) {
  const host = location.hostname, parts = host.split('.');
  const domains = ['', host, parts.length > 2 ? '.' + parts.slice(-2).join('.') : ''].filter((d, i, a) => a.indexOf(d) === i);
  domains.forEach((d) => {
    document.cookie = v ? `googtrans=${v}; path=/${d ? `; domain=${d}` : ''}` : `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${d ? `; domain=${d}` : ''}`;
  });
}

export function applyAutoTranslate(lang: string) {
  if (typeof document === 'undefined') return;
  const target = GT[lang];
  const had = /googtrans=\/en\/[\w-]+/.test(document.cookie);
  if (!target) {
    if (had) { setCookie(null); location.reload(); }
    return;
  }
  const want = `/en/${target}`;
  const cur = /googtrans=([^;]+)/.exec(document.cookie)?.[1];
  setCookie(want);
  if (loaded) {
    if (cur !== want) {
      const sel = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (sel) { sel.value = target; sel.dispatchEvent(new Event('change')); } else location.reload();
    }
    return;
  }
  loaded = true;
  // Google wraps text in <font> tags, which can confuse React when it updates the page. Make those DOM calls forgiving.
  const P = Node.prototype as unknown as { removeChild: <T extends Node>(c: T) => T; insertBefore: <T extends Node>(n: T, r: Node | null) => T; __ck?: boolean };
  if (!P.__ck) {
    P.__ck = true;
    const rc = P.removeChild, ib = P.insertBefore;
    P.removeChild = function <T extends Node>(this: Node, c: T): T { if (c.parentNode !== this) { c.parentNode?.removeChild(c); return c; } return rc.call(this, c) as T; };
    P.insertBefore = function <T extends Node>(this: Node, n: T, r: Node | null): T { if (r && r.parentNode !== this) return ib.call(this, n, null) as T; return ib.call(this, n, r) as T; };
  }
  if (!document.getElementById('gt-el')) { const d = document.createElement('div'); d.id = 'gt-el'; d.style.display = 'none'; document.body.appendChild(d); }
  if (!document.getElementById('gt-style')) {
    const st = document.createElement('style'); st.id = 'gt-style';
    st.textContent = '.goog-te-banner-frame,.skiptranslate iframe,#goog-gt-tt,.goog-te-balloon-frame,.VIpgJd-ZVi9od-ORHb-OEVmcd,.VIpgJd-ZVi9od-aZ2wEe-wOHMyf{display:none!important}body{top:0!important}.goog-text-highlight{background:none!important;box-shadow:none!important}font{background:none!important;box-shadow:none!important}';
    document.head.appendChild(st);
  }
  (window as unknown as Record<string, unknown>).ckGtInit = () => {
    const g = (window as unknown as { google?: { translate?: { TranslateElement: new (o: object, id: string) => unknown } } }).google;
    if (g?.translate) new g.translate.TranslateElement({ pageLanguage: 'en', autoDisplay: false, includedLanguages: Object.values(GT).join(',') }, 'gt-el');
  };
  const sc = document.createElement('script');
  sc.src = 'https://translate.google.com/translate_a/element.js?cb=ckGtInit';
  sc.async = true;
  document.head.appendChild(sc);
}
